var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileSizeExceedsCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6997 2.33435C10.5797 -0.777792 5.45987 -0.777792 2.33994 2.33435C-0.779981 5.4465 -0.779981 10.5536 2.33994 13.6658C5.45987 16.7779 10.4997 16.7779 13.6197 13.6658C16.7396 10.5536 16.8196 5.4465 13.6997 2.33435ZM10.2598 11.3516L8.01981 9.11723L5.77986 11.3516L4.65989 10.2344L6.89983 8.00005L4.65989 5.76569L5.77986 4.64851L8.01981 6.88287L10.2598 4.64851L11.3797 5.76569L9.13978 8.00005L11.3797 10.2344L10.2598 11.3516Z",
    fill: "#D00026"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSizeExceedsCross);
export default __webpack_public_path__ + "static/media/file-size-exceeds-cross.9d3212546e0167d0540c2471d27070bc.svg";
export { ForwardRef as ReactComponent };